import { APIUrls } from "../../Constants/ApiUrls";
import { ISystemSetting } from "../../Models/ISystemSetting";
// import { IUser, IUserEdit } from "../../Models/IUser"; //Fix Warning Complaint Code:071225
import { AjaxService, IAPIRequest, IAPIResponse } from "../AjaxService";

const SystemSettingController = {
  GetSettingsList: async (callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SYSTEM_SETTINGS.SYSTEM_SETTINGS_GET;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  CreateOrEditSetting: async (
    setting: ISystemSetting,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SYSTEM_SETTINGS.SYSTEM_SETTINGS_EDIT_OR_CREATE;
    request.method = "POST";
    request.payload = setting;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
};

export default SystemSettingController;
